import { useEffect } from 'react';

import { makeVar, useReactiveVar } from '@/utility/reactiveVariable';

import { ELocalityGuidedSearchVariationKey, OptimizelyFlags } from './flags';
import { useOptimizelyDecision } from './index';

// Re-export for convenience
export { ELocalityGuidedSearchVariationKey };

const localityGuidedSearchDecision = makeVar<{ variation?: string; enabled: boolean }>({
  variation: undefined,
  enabled: false,
});

export const useLocalityGuidedSearchDecision = () => {
  return useReactiveVar(localityGuidedSearchDecision);
};

// Initialize the locality guided search experiment decision.
// This component should be rendered on locality pages to initialize the experiment
// and make the decision available via reactive variables throughout the app.
export const InitLocalityGuidedSearchDecision = () => {
  const decision = useOptimizelyDecision(OptimizelyFlags.LOCALITY_GUIDED_SEARCH);

  useEffect(() => {
    localityGuidedSearchDecision({
      variation: decision?.variationKey || undefined,
      enabled: Object.values(ELocalityGuidedSearchVariationKey).includes(
        decision?.variationKey as ELocalityGuidedSearchVariationKey,
      ),
    });
  }, [decision]);

  return null;
};
